<div class="playlist-item" (contextmenu)="$event.preventDefault()"
  [ngClass]="{ 'selected': item.isSelected }"
  (mouseenter)="showHoverElements = true" (mouseleave)="showHoverElements = false"
  (mousedown)="hideContentPreview()"
  #popover="ngbPopover"
  [ngbPopover]="popContent"
  [disablePopover]="this.itemsSelection$ | async"
  [animation]="true"
  triggers="manual"
  placement="top"
  popoverClass="content-preview-popover">

  <ng-template #popContent>
    <img [src]="item.PlaylistItemLinks[0].content">
  </ng-template>

  <div class="d-flex align-items-center w-100">
    <div class="monitors-divider-select" *ngIf="isMawChromeLauncher"
      [ngClass]="{ 'portrait-view': selectedMode.includes(appConst.PORTRAIT_VIEW) }">
        <div class="monitor-blue" [ngClass]="{
          'portrait-view': selectedMode.includes(appConst.PORTRAIT_VIEW),
          'flex-column': selectedMode.includes(appConst.COLUMN_VIEW) }"
          [style.border-bottom]="item.RssConfigs?.Url || item.RssConfigs?.FileId ? '2px solid' : 'none'"
          [style.border-bottom-color]="item.RssConfigs?.Url || item.RssConfigs?.FileId ? item.RssConfigs.BackgroundColor : 'transparent'">
            <ng-container *ngFor="let count of mawChromeParts | numberToArray; let i = index">
              <div class="monitor-blocks"
                [ngClass]="{
                  'four-monitors': selectedMode === appConst.FOUR_MONITORS_OPTION,
                  'five-monitors': selectedMode === appConst.FIVE_MONITORS_1_ROW_REST_COLUMN_OPTION,
                  'five-monitors-reversed': selectedMode === appConst.FIVE_MONITORS_5_COLUMN_OPTION,
                  'six-monitors': selectedMode === appConst.SIX_MONITORS_OPTION,
                  'nine-monitors': selectedMode === appConst.NINE_MONITORS_OPTION,
                  'two-monitors-unequal': selectedMode === appConst.TWO_MONITORS_ROW_UNEQUAL_OPTION,
                  'two-monitors-unequal-reversed': selectedMode === appConst.TWO_MONITORS_ROW_UNEQUAL_REVERSED_OPTION,
                  'three-monitors-1-row-2-column': selectedMode === appConst.TREE_MONITORS_1_ROW_2_3_COLUMN_OPTION,
                  'three-monitors-2-column-3-row': selectedMode === appConst.TREE_MONITORS_1_2_COLUMN_3_ROW_OPTION,
                  'five-monitors-2-column-1-row-2-column': selectedMode === appConst.FIVE_MONITORS_1_2_COLUMN_3_ROW_4_5_COLUMN_OPTION
                }">{{ i + 1 }}</div>
            </ng-container>
        </div>
    </div>

    @let isForegroundItem = item.PlaylistItemType === playlistItemsTypes.Foreground;

    <span *ngIf="!isMawChromeLauncher && !item.IsLocal && !isForegroundItem" class="file-icon">
      <img [src]="item.PlaylistItemLinks[0].icon"></span>

    @if (item.IsLocal && playlist.IsAndroid) {
      <mat-icon class="small-icon mr-2" svgIcon="folder_data"></mat-icon>
    }
    @else if (item.IsLocal) {
      <mat-icon class="local" matTooltip="Local playlist item will be played only in the created location" svgIcon="playlist_play"></mat-icon>
    }

    @if (isForegroundItem) {
      <mat-icon svgIcon="picture_in_picture" class="foreground-icon small-icon"
        matTooltip="Foreground playlist item will appear on top of all other items throughout the entire playlist loop"></mat-icon>
    }

    <div class="playlist-item-title" (mouseenter)="showContentPreview()" (mouseleave)="hideContentPreview()"
      [style.cursor]="item.PlaylistFileName ? 'pointer' : 'text'"
      [matTooltip]="item.PlaylistItemTitle"
      (click)="item.PlaylistFileName ? item.isSelected = !item.isSelected : null">
        {{ item.PlaylistItemTitle }}
    </div>

    <div class="float-right">
      <mat-icon (click)="delete()" [hidden]="!showHoverElements" class="action-button" svgIcon="close"
        matTooltip="Delete item"></mat-icon>
      <mat-icon (click)="editItem.emit()" [hidden]="!showHoverElements" class="action-button" svgIcon="edit"
        [matTooltip]="item.isSelected ? 'Edit selected items' : 'Edit item'"></mat-icon>
      <mat-icon (click)="duplicate()" [hidden]="!showHoverElements || isForegroundItem " class="action-button" svgIcon="content_copy"
        matTooltip="Duplicate item"></mat-icon>
      <mat-icon (click)="download()" class="action-button download" svgIcon="arrow_downward" [hidden]="!showHoverElements || !item.PlaylistFileName"
        matTooltip="Download file">
      </mat-icon>
    </div>
  </div>

  <div *ngIf="item.IsLocal && !playlist.IsAndroid" class="local w-100">
    <p class="m-0">Location:
      <span [matTooltip]="playlist.Machine?.Title">{{playlist.Machine?.Title}}</span>
    </p>
  </div>
</div>
